export const accMessageBarDismissLink = "hOFfyb";
export default {accMessageBarDismissLink};